<div class="w-100">
  <button class="color-dark bg-transparent d-flex align-items-center fw-bold gap-2 cursor-pointer w-fit-content px-3 py-2" (click)="routeToProfile()" aria-label="Go back to profile">
    <i class="bi bi-chevron-left" aria-hidden="true"></i>
    Back
  </button>
</div>